import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    getSearchList: (state, action) => {
      state.search = action.payload;
    },
  },
});

export const { getSearchList } = searchSlice.actions;
export default searchSlice.reducer;
